import gql from 'graphql-tag'

export const CREATE_WASTE = gql`
  mutation createWaste($input: CreateWasteInput!) {
    createWaste(input: $input) {
      waste {
        id
      }
      errors
    }
  }
`

export default {
  CREATE_WASTE
}
